import InitApi from "api/InitApi";
import { useQuery } from "react-query";
import useTokenStore from "store/tokenStore";
import { deleteEmptyObjects, fetchConfig } from "utils";

const useGetFeaturedBooks = (queryParams) => {
	const { accessToken } = useTokenStore();
	const fetch = async () => {
		const apiVersion = "v2";
		const instance = await InitApi({ accessToken, apiVersion });
		const params = queryParams ? deleteEmptyObjects(queryParams) : null;
		const res = await instance.get("books/featured", {
			params,
		});
		return res?.data?.data;
	};
	return useQuery(["books", "featured"], () => fetch(), {
		...fetchConfig,
	});
};

export default useGetFeaturedBooks;
